<template>
  <div class="user-disorder-list">
    <ul
      v-if="userDisorders.length > 0"
      class="user-disorder-list__disorders"
    >
      <li
        v-for="userDisorder in userDisorders"
        :key="userDisorder.id"
        class="user-disorder-list__disorder"
        data-test-id="user-disorder-list-item"
      >
        <div v-if="showBadges" class="user-disorder-list__badge-container">
          <icon-component
            v-if="badgeIcons[userDisorder.relationshipType]"
            :name="badgeIcons[userDisorder.relationshipType]"
            title="Health Profile Badge"
            class="user-disorder-list__badge"
          />
          <div v-else class="user-disorder-list__badge-placeholder" />
        </div>
        <div class="user-disorder-list__disorder-container">
          <p class="user-disorder-list__disorder-name" data-test-id="user-disorder-list-item-disorder-name">
            {{ userDisorder.disorder.name }}
          </p>
          <p
            v-if="userDisorder.relationshipType"
            class="user-disorder-list__disorder-relationship"
            data-test-id="user-disorder-list-item-disorder-relationship"
          >
            {{ formatRelationshipType(userDisorder.relationshipType) }}
          </p>
        </div>
        <div v-if="showDeleteButtons" class="user-disorder-list__button-container">
          <button
            class="user-disorder-list__button text-button"
            data-test-id="user-disorder-list-delete-button"
            type="button"
            @click="emitDelete(userDisorder.id)"
          >
            <icon-component
              name="trash-can"
              title="trash-can icon"
              class="
                user-disorder-list__button-icon
                user-disorder-list__button-icon--delete
              "
            />
            Delete
          </button>
        </div>
      </li>
    </ul>
    <div v-else class="user-disorder-list__no-disorders">
      <p
        class="user-disorder-list__no-disorders-message"
        data-test-id="user-disorder-list-no-disorders-message"
      >You have not added any health conditions yet.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserDisorderList',
  props: {
    userDisorders: {
      type: Array,
      default: () => [],
    },
    showBadges: {
      type: Boolean,
    },
    showDeleteButtons: {
      type: Boolean,
    },
  },
  data() {
    return {
      badgeIcons: {
        patient: 'badge-member',
        caregiver: 'badge-caregiver',
        healthcare_provider: 'badge-healthcare-provider',
        null: '',
      },
    };
  },
  methods: {
    formatRelationshipType(relationshipType) {
      return relationshipType.charAt(0).toUpperCase() + relationshipType.slice(1).replace('_', ' ');
    },
    emitDelete(userDisorderId) {
      this.$emit('delete-disorder', userDisorderId);
    },
  },
};

</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_user-disorder-list';
</style>
